import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { LOCAL_STORAGE } from '@constants';
import getValidatedParams from 'utils/getValidatedParams';
import { safeUtmString } from 'utils/schemaUtils';
import { isUtmParam } from 'utils/getBrowserUtmData';

const PARAMS_WHITELIST = new Set([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'redirectTo',
  'verificationSecondaryEmailCode',
  'paymentMethodCategoryId',
  'transactionId',
  'response_path',
  'tab',
  'code',
  'promotionId',
  'userId',
  'layout',
  'walletCurrency',
  'localCurrency',
  'walletAmount',
  'localAmount',
  'recipient',
  'concept',
  'disabledInputs',
  'depositWalletAddress',
  'gclid',
  'fbclid',
  'ttclid',
  'uid',
]);

function useCleanAndValidateQueryParams() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const cleanedParams = Array.from(searchParams.entries()).reduce((acc, [k, v]) => {
      if (PARAMS_WHITELIST.has(k)) {
        Object.assign(acc, { [k]: v });
      }
      return acc;
    }, {});

    const cleanedSearch = new URLSearchParams(cleanedParams).toString();

    // Save UTM data from search params in session storage
    const utmData = Object.entries(cleanedParams).reduce((acc: any, [key, value]) => {
      if (isUtmParam(key)) {
        const validParams = getValidatedParams({
          params: { [key]: value },
          schema: { [key]: safeUtmString },
        });

        acc[key] = key in validParams ? validParams[key] : undefined;
      }
      return acc;
    }, {});
    if (Object.keys(utmData).length > 0) {
      sessionStorage.setItem(LOCAL_STORAGE.UTM, JSON.stringify(utmData));
    }

    // Redirect if the query string differs from the cleaned version
    if (cleanedSearch !== location.search.substring(1)) {
      history.replace(`${location.pathname}?${cleanedSearch}`);
    }
  }, [location, history]);
}

export default useCleanAndValidateQueryParams;
